import {api_smart} from '@/utils/request'
import axios from '@/utils/request'

//扫码活动概况
export const showSurvey = (params)=>{
  return api_smart.request({
     url: 'admin/activitys/show_survey',
     method: 'get',
     params
   })
};



//扫码活动管理 --活动列表
export const activitys = (params)=>{
  return api_smart.request({
     url: 'admin/activitys',
     method: 'get',
     params
   })
};
//扫码活动管理 --活动活动禁用及修改优先
export const activitysSwitch= (id,data)=>{
  return api_smart.request({
     url: 'admin/activitys/switch_options/'+id,
     method: 'PATCH',
     data
   })
};
//扫码活动管理 --活动活动删除
export const activitysDel= (id)=>{
  return api_smart.request({
     url: 'admin/activitys/'+id,
     method: 'DELETE'
   })
};
//扫码活动管理 --活动活动数据
export const activitysStatics= (activity_id)=>{
  return api_smart.request({
     url: 'admin/activitys/show_statistics/'+activity_id,
     method: 'get'
   })
};
//扫码活动管理 --活动活动资料收集列表
export const getCollectionList= (activity_id,params)=>{
  return api_smart.request({
     url: 'admin/activitys/show_collection/'+activity_id,
     method: 'get',
     params
   })
};


//扫码活动管理 --活动活动资料收集详情
export const showCollectionInfo= (activity_id,params)=>{
  return api_smart.request({
     url: 'admin/activitys/show_collection_info/'+activity_id,
     method: 'get',
     params
   })
};



// 创建活动第一步
// 添加
export const activitysOneCreate = (data)=>{
  return api_smart.request({
     url: 'admin/activitys/base',
     method: 'post',
     data
   })
};
// 详情
export const activitysOneDetail = (activity_id,params)=>{
  return api_smart.request({
     url: 'admin/activitys/base/'+activity_id,
     method: 'get',
     params
   })
};
// 更新
export const activitysOneUpdate = (activity_id,data)=>{
  return api_smart.request({
     url: 'admin/activitys/base/'+activity_id,
     method: 'PUT',
     data
   })
};
// 第一步结束


// 创建活动第二步
// 详情
export const activitysTwoDetail = (activity_id,params)=>{
  return api_smart.request({
     url: 'admin/activitys/ranges/'+activity_id,
     method: 'get',
     params
   })
};
// 活动范围-添加
export const activitysTwoUpdate = (activity_id,data)=>{
  return api_smart.request({
     url: 'admin/activitys/ranges/'+activity_id,
     method: 'PUT',
     data
   })
};
// 活动范围-删除
export const activitysTwoDel = (activity_id,data)=>{
  return api_smart.request({
     url: 'admin/activitys/ranges/'+activity_id,
     method: 'DELETE',
     data
   })
};
// 第二步结束

// 第三步开始
// 奖项列表
export const activitysTreeList = (activity_id)=>{
  return api_smart.request({
     url: 'admin/activity/awards/index/'+activity_id,
     method: 'get'
   })
};
// 奖项创建
export const activitysTreeCreate = (activity_id,data)=>{
  return api_smart.request({
     url: 'admin/activity/awards/'+activity_id,
     method: 'post',
     data
   })
};
// 活动-添加奖项-获取可用的数量
export const activitysNum = (activity_id,award_id)=>{
  if(award_id){
    return api_smart.request({
      url: 'admin/activity/awards/num/'+activity_id+'/'+award_id,
      method: 'get'
    })
  }else{
    return api_smart.request({
      url: 'admin/activity/awards/num/'+activity_id,
      method: 'get'
    })
  }
};
// 奖项详情
export const activitysTreeDetail = (award_id,params)=>{
  return api_smart.request({
     url: 'admin/activity/awards/'+award_id,
     method: 'get',
     params
   })
};
// 奖项修改
export const activitysTreeUpdate = (award_id,data)=>{
  return api_smart.request({
     url: 'admin/activity/awards/'+award_id,
     method: 'PUT',
     data
   })
};
// 活动范围-删除
export const activitysTreeDel = (award_id)=>{
  return api_smart.request({
     url: 'admin/activity/awards/'+award_id,
     method: 'DELETE'
   })
};

// 第三步结束


// 第四步

// 自定义字段-列表
export const activitysFourCustomizesList = ()=>{
  return api_smart.request({
     url: 'admin/activity/ploy/customizes/index',
     method: 'get'
   })
};
// 自定义字段-新增
export const activitysFourCustomizesCreate = (data)=>{
  return api_smart.request({
     url: 'admin/activity/ploy/customizes',
     method: 'post',
     data
   })
};
// 自定义 字段类型 选项
export const activitysFourCustomizestypeOption = ()=>{
  return api_smart.request({
     url: 'admin/activity/ploy/customizes/type_option',
     method: 'get'
   })
};
// 自定义 字段更新
export const activitysFourCustomizestypeUpdate = (customize_id,data)=>{
  return api_smart.request({
     url: 'admin/activity/ploy/customizes/'+customize_id,
     method: 'PUT',
     data
   })
};

export const activitysFourCustomizestypeDelete = (customize_id,data)=>{
  return api_smart.request({
     url: 'admin/activity/ploy/customizes/'+customize_id,
     method: 'DELETE',
     data
   })
};
// 自定义 字段详情
export const activitysFourCustomizestypeDetail = (customize_id)=>{
  return api_smart.request({
     url: 'admin/activity/ploy/customizes/'+customize_id,
     method: 'get'
   })
};

// 策略-基础信息详情
export const activitysFourDetail = (activity_id)=>{
  return api_smart.request({
     url: 'admin/activity/ploys/base/'+activity_id,
     method: 'get'
   })
};

// 策略-优先级跟新
export const updatePloySort = (ploy_id,data)=>{
  return api_smart.request({
     url: 'admin/activity/ploys/switch_options/'+ploy_id,
     method: 'PATCH',
     data
   })
};
// 策略-字段收集列表
export const activitysFourCustomizesSelectList = (activity_id)=>{
  return api_smart.request({
     url: 'admin/activity/ploy/customizes/select_list/'+activity_id,
     method: 'get'
   })
};
// 策略-基础信息更新
export const activitysFourUpdate = (activity_id,data)=>{
  return api_smart.request({
     url: 'admin/activity/ploys/base/'+activity_id,
     method: 'PUT',
     data
   })
};
// 策略-列表
export const activitysFourPloysList = (activity_id)=>{
  return api_smart.request({
     url: 'admin/activity/ploys/index/'+activity_id,
     method: 'get'
   })
};
// 策略-添加
export const activitysFourPloysCreate = (activity_id,data)=>{
  return api_smart.request({
     url: 'admin/activity/ploys/'+activity_id,
     method: 'post',
     data
   })
};
// 策略-删除
export const activitysFourPloysDel = (activity_id,data)=>{
  return api_smart.request({
     url: 'admin/activity/ploys/'+activity_id,
     method: 'DELETE',
     data
   })
};
// 策略-奖项列表
export const activitysFourPloysAward = (ploy_id)=>{
  return api_smart.request({
     url: 'admin/activity/ploys/award/'+ploy_id,
     method: 'get',
   })
};
// 策略-奖项添加
export const activitysFourPloysAwardUpdate = (ploy_id,data)=>{
  return api_smart.request({
     url: 'admin/activity/ploys/award/'+ploy_id,
     method: 'PUT',
     data
   })
};
// 策略-详情
export const activitysFourPloysDetail = (ploy_id)=>{
  return api_smart.request({
     url: 'admin/activity/ploys/'+ploy_id,
     method: 'get'
   })
};
// 策略-修改
export const activitysFourPloysEdit= (ploy_id,data)=>{
  return api_smart.request({
     url: 'admin/activity/ploys/'+ploy_id,
     method: 'PUT',
     data
   })
};
// 策略-修改状态
export const activitysFourPloysUpdate = (ploy_id,data)=>{
  return api_smart.request({
     url: 'admin/activity/ploys/switch_options/'+ploy_id,
     method: 'PATCH',
     data
   })
};
// 策略-禁用启用
export const activitysFourPloysStatus = (ploy_id,data)=>{
  return api_smart.request({
     url: 'admin/activity/ploys/switch_options/'+ploy_id,
     method: 'PATCH',
     data
   })
};


// 系统模板列表
export const getSysTemplates = (params)=>{
  return api_smart.request({
     url: 'admin/templates/sys_templates',
     method: 'get',
     params
   })
};
// 系统模板类型
export const getTemplatesTypeList = (params)=>{
  return api_smart.request({
     url: 'admin/code/templates/templates_type_list',
     method: 'get',
     params
   })
};

// 模板列表
export const getTemplates = (params)=>{
  return api_smart.request({
     url: 'admin/templates',
     method: 'get',
     params
   })
};

// 商品关联模板列表
export const get_trace_templates_list = (params)=>{
  return api_smart.request({
     url: 'admin/code/templates/get_trace_templates_list',
     method: 'get',
     params
   })
};
// 取消商品关联模板
export const un_bind_product = (data)=>{
  return api_smart.request({
     url: 'admin/code/templates/un_bind_product',
     method: 'post',
     data
   })
};
// 新增商品关联模板
export const bind_product = (data)=>{
  return api_smart.request({
     url: 'admin/code/templates/bind_product',
     method: 'post',
     data
   })
};
// 是否有定制模板
export const is_have_customized = (params)=>{
  return api_smart.request({
     url: '/admin/code/templates/customized/is_have_customized',
     method: 'get',
     params
   })
};
// 定制模板列表
export const getCustomizedTemplates = (params)=>{
  return api_smart.request({
     url: 'admin/code/templates/customized/list',
     method: 'get',
     params
   })
};
// 活动模板列表
export const getActivityTemplate = (params)=>{
  return api_smart.request({
     url: 'admin/templates/get_activity_template',
     method: 'get',
     params
   })
};


// 模板配置
export const getAdvertisement = (params)=>{
  return api_smart.request({
     url: 'admin/templates/advertisement/show',
     method: 'get',
     params
   })
};
// 模板更新
export const updateAdvertisement = (data)=>{
  return api_smart.request({
     url: 'admin/templates/advertisement/update',
     method: 'PUT',
     data
   })
};
// 模板添加标签
export const createTags = (data)=>{
  return api_smart.request({
     url: 'admin/templates/tags',
     method: 'post',
     data
   })
};
// 模板修改标签
export const updateTags = (data)=>{
  return api_smart.request({
     url: 'admin/templates/tags',
     method: 'PUT',
     data
   })
};

// 模板删除标签
export const deleteTags = (data)=>{
  return api_smart.request({
     url: 'admin/templates/tags',
     method: 'DELETE',
     data
   })
};
// 添加模板
export const setTemplates = (data)=>{
  return api_smart.request({
     url: 'admin/templates',
     method: 'post',
     data
   })
};
// 修改模板
export const updateTemplates = (id,data)=>{
  return api_smart.request({
     url: 'admin/templates/'+id,
     method: 'PUT',
     data
   })
};
// 删除模板
export const delTemplates = (id)=>{
  return api_smart.request({
     url: 'admin/templates/'+id,
     method: 'DELETE'
   })
};

// 模板详情
export const detailTemplates = (id)=>{
  return api_smart.request({
     url: 'admin/templates/'+id,
     method: 'get'
   })
};
// 设置默认模板
export const setDefault = (data)=>{
  return api_smart.request({
     url: 'admin/code/templates/set_default',
     method: 'post',
     data
   })
};

/**
 * 领奖管理
 * 
 */

//领奖记录-列表
export const getAwardList = (params)=>{
  return api_smart.request({
     url: 'admin/activity/award/log/index',
     method: 'get',
     params
   })
};

//领奖记录-一些字段
export const getAwardCount = (params)=>{
  return api_smart.request({
     url: 'admin/activity/award/log/count',
     method: 'get',
     params
   })
};

//领奖记录-详情
export const getAwardMore = (id)=>{
  return api_smart.request({
     url: 'admin/activity/award/log/'+id,
     method: 'get'
   })
};
//领奖记录-优惠券详情
export const getMemberCoupon = (params)=>{
  return axios.request({
     url: 'v1/memberCoupon/log',
     method: 'get',
     params
   })
};


//领奖记录-补发
export const setAwardRepair = (id)=>{
  return api_smart.request({
     url: 'admin/activity/award/log/repair/'+id,
     method: 'post'
   })
};

/**
 * 实物奖品兑换管理
 */

//实物中奖记录
export const getEntityList = (params)=>{
  return api_smart.request({
     url: 'admin/activity/entityaward/index',
     method: 'get',
     params
   })
};
//实物中奖详情
export const getEntityMore = (id)=>{
  return api_smart.request({
     url: 'admin/activity/entityaward/'+id,
     method: 'get'
   })
};
//实物中奖-发货
export const setEntityDeliver = (data)=>{
  return api_smart.request({
     url: 'admin/activity/entityaward/deliver/'+data.id,
     method: 'post',
     data
   })
};
//实物中奖-修改地址
export const setEntityAddress = (data)=>{
  return api_smart.request({
     url: 'admin/activity/entityaward/address/'+data.id,
     method: 'post',
     data
   })
};

// 统计


//扫码量统计
export const statisticsScan = (params)=>{
  return api_smart.request({
     url: 'admin/activity/statistics/scan',
     method: 'get',
     params
   })
};
//扫码量地区统计
export const statisticsScanArea = (params)=>{
  return api_smart.request({
     url: 'admin/activity/statistics/scan_area',
     method: 'get',
     params
   })
};
//参与量统计
export const statisticsAttend = (params)=>{
  return api_smart.request({
     url: 'admin/activity/statistics/attend',
     method: 'get',
     params
   })
};
//参与量地区统计
export const statisticsAttendArea = (params)=>{
  return api_smart.request({
     url: 'admin/activity/statistics/attend_area',
     method: 'get',
     params
   })
};

//用户统计
export const statisticsUser = (params)=>{
  return api_smart.request({
     url: 'admin/activity/statistics/user',
     method: 'get',
     params
   })
};
//用户地区统计
export const statisticsUserArea = (params)=>{
  return api_smart.request({
     url: 'admin/activity/statistics/user_area',
     method: 'get',
     params
   })
}

//奖项统计
export const statisticsAward = (params)=>{
  return api_smart.request({
     url: 'admin/activity/statistics/award',
     method: 'get',
     params
   })
};
//奖项地区统计
export const statisticsAwardArea = (params)=>{
  return api_smart.request({
     url: 'admin/activity/statistics/award_area',
     method: 'get',
     params
   })
}
// 领奖记录-导出
export const awardLogsExport = (params)=>{
  return api_smart.request({
     url: 'admin/activity/award/log/export',
     method: 'get',
     params
   })
};
// 扫一扫配置详情
export const getScanPageDetail = (params)=>{
  return api_smart.request({
     url: 'admin/templates/scan/detail',
     method: 'get',
     params
   })
};
//扫一扫配置更新
export const setScanPageDetail = (data)=>{
  return api_smart.request({
     url: 'admin/templates/scan/update',
     method: 'post',
     data
   })
};
// 扫一扫链接
export const getScanPageUrl = (params)=>{
  return api_smart.request({
     url: 'admin/templates/scan/site',
     method: 'get',
     params
   })
};
// 物流码扫码模板-详情
export const getLogisticsPageDetail = (params)=>{
  return api_smart.request({
     url: 'admin/logistics_templates',
     method: 'get',
     params
   })
};
//物流码扫码模板-更新
export const setLogisticsPageDetail = (data)=>{
  return api_smart.request({
     url: 'admin/logistics_templates',
     method: 'post',
     data
   })
};
// 物流码扫码模板-详情
export const entityawardExport = (params)=>{
  return api_smart.request({
     url: 'admin/activity/entityaward/export',
     method: 'get',
     params
   })
};



// 出库单模式 ---活动范围
export const activitysRangeList = (activity_id,params)=>{
  return api_smart.request({
     url: 'admin/marketing/activity/ranges/chd_mode/range_list/'+activity_id,
     method: 'get',
     params:{activity_id}
   })
};

// 出库单模式 ---已选出库单列表
export const activitysRangeOutList = (range_id,params)=>{
  return api_smart.request({
     url: 'admin/marketing/activity/ranges/chd_mode/show_range_out_warehousing_sn_list/'+range_id,
     method: 'get',
     params
   })
};

// 数据更新
export const activitysSnRangeUpdateData = (activity_id)=>{
  return api_smart.request({
     url: 'admin/marketing/activity/ranges/chd_mode/refresh/'+activity_id,
     method: 'get'
   })
};
// 数据更新记录
export const activitysSnRangeUpdateDataLogs = (range_id,params)=>{
  return api_smart.request({
     url: 'admin/marketing/activity/ranges/chd_mode/get_refresh_log/'+range_id,
     method: 'get',
     params
   })
};
//自动条件 -详情
export const show_range_info = (id)=>{
  return api_smart.request({
     url: 'admin/marketing/activity/ranges/chd_mode/show_range_info/'+id,
     method: 'get'
   })
};
//自动条件 -修改
export const update_matching_condition_to_range = (data)=>{
  return api_smart.request({
     url: 'admin/marketing/activity/ranges/chd_mode/update_matching_condition_to_range',
     method: 'PUT',
     data
   })
};

// 删除
export const delRanges = (range_id)=>{
  return api_smart.request({
     url: 'admin/marketing/activity/ranges/chd_mode/'+range_id,
     method: 'DELETE',
     
   })
};

//增加入库单 条件
export const set_out_warehousing_list = (data)=>{
  return api_smart.request({
     url: 'admin/marketing/activity/ranges/chd_mode/store_out_warehousing_sn_to_range',
     method: 'post',
     data
   })
};
//修改入库单 条件
export const update_out_warehousing_list = (data)=>{
  return api_smart.request({
     url: 'admin/marketing/activity/ranges/chd_mode/update_out_warehousing_sn_to_range',
     method: 'PUT',
     data
   })
};

//添加范围->指定匹配条件
export const store_matching_condition_to_range = (data)=>{
  return api_smart.request({
     url: 'admin/marketing/activity/ranges/chd_mode/store_matching_condition_to_range',
     method: 'post',
     data
   })
};

// 获取入库单号
export const get_out_warehousing_list = (params)=>{
  return api_smart.request({
     url: 'admin/marketing/activity/ranges/chd_mode/get_out_warehousing_list',
     method: 'get',
     params
   })
};

// 附加奖项列表
export const activityAttach = (params)=>{
  return api_smart.request({
     url: 'admin/marketing/activity/award/attach/index',
     method: 'get',
     params
   })
};
// 附加奖项删除
export const activityAttachDel = (activity_id,award_id,attach_award_id)=>{
  return api_smart.request({
     url: 'admin/marketing/activity/award/attach/delete/'+activity_id+'/'+award_id+'/'+attach_award_id,
     method: 'DELETE'
   })
};
// 附加奖项详情
export const activityAttachDetail = (activity_id,award_id,attach_award_id)=>{
  return api_smart.request({
     url: 'admin/marketing/activity/award/attach/show/'+activity_id+'/'+award_id+'/'+attach_award_id,
     method: 'get'
   })
};

// 附加奖-添加
export const attachStore = (data)=>{
  return api_smart.request({
     url: 'admin/marketing/activity/award/attach/store',
     method: 'post',
     data
   })
};

// 附加奖-修改
export const attachUpdate = (data)=>{
  return api_smart.request({
     url: 'admin/marketing/activity/award/attach/update',
     method: 'post',
     data
   })
};

// 导出列表-异步
export const marketingExport = (params)=>{
  return api_smart.request({
     url: 'admin/marketing/export',
     method: 'get',
     params
   })
};

// 奖品统计-导出
export const awardExport = (params)=>{
  return api_smart.request({
     url: 'admin/activity/statistics/awardExport',
     method: 'get',
     params
   })
};
// 活动收集信息管理
export const  memberCollectionsList= (params)=>{
  return api_smart.request({
     url: 'admin/activitys/memberCollectionsList',
     method: 'get',
     params
   })
};
//兑换码类礼品
export const getTotal = (id)=>{ 
  return axios.request({
    url: 'v1/order/express/read?id='+id,
    method: 'get'
  })
};
//获取开奖渠道统计
export const getTotalCom = (params)=>{ 
  return api_smart.request({
    url: 'admin/activity/statistics/channel',
    method: 'get',
    params
  })
};
//开奖明细
export const getprizeList = (params)=>{ 
  return api_smart.request({
    url: 'admin/activity/statistics/channel/scan/'+params.id,
    method: 'get',
    params
  })
};
//
export const activitysRangeDetail = (activity_id,params)=>{
  return api_smart.request({
     url: 'admin/activitys/ranges/detail/'+activity_id,
     method: 'get',
     params
   })
};

//活动可选的码批次列表
export const activitysSelectBatchList = (params)=>{
  return api_smart.request({
     url: 'admin/code_batchs/select_batch_list',
     method: 'get',
     params
   })
};

//物流信息
export const guideOrderLogistics = (params)=>{
  return axios.request({
     url: '/v2/order/logistics',
     method: 'get',
     params
   })
};

//获取第几球数
export const getBallNum = (activity_id)=>{
  return api_smart.request({
     url: 'admin/activity/awards/ball_num/'+activity_id,
     method: 'get'
   })
};